import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { getLeadAPI } from '../services/Leadservice';


export const ShowFinishedDealDetails = ({ docID }) => {
    const [lead, setLead] = React.useState({});
    const [show, setShow] = React.useState(false);


    const handleClose = () => {

        setShow(false);

    }
    const handleShow = () => setShow(true);

    useEffect(() => {
        const getLead = async () => {
            setLead(await getLeadAPI(docID));
        }

        getLead();
    }, [])



    return (
        <Button onClick={handleShow}>
            Visa detailjer
        </Button>
    )
}